import { useCallback } from 'react';
import { useShallow } from 'zustand/react/shallow';
import useNotificationStore from '@/stores/useNotificationStore';

// Hook for destination components to clear redirect state after successful navigation
export function useClearRedirectState() {
  const { clearPendingWebRedirect, clearCurrentDeepLink } =
    useNotificationStore(
      useShallow((state) => ({
        clearPendingWebRedirect: state.clearPendingWebRedirect,
        clearCurrentDeepLink: state.clearCurrentDeepLink,
      })),
    );

  const clearRedirectState = useCallback(() => {
    clearPendingWebRedirect();
    clearCurrentDeepLink();
  }, [clearPendingWebRedirect, clearCurrentDeepLink]);

  return { clearRedirectState };
}
